import * as types from "./mutation_types";

export default {
  // common
  [types.COMMON_CODE_MAP](state, coCodeMap) {
    state.coCodeMap = coCodeMap;
  },
  [types.COMMON_CODE_MAP_DETAIL](state, coCodeMapDetail) {
    state.coCodeMapDetail = coCodeMapDetail;
  },
  // property
  [types.TARGET_JUSO](state, targetJuso) {
    state.targetJuso = targetJuso;
  },
  // login
  [types.AUTH_TOKEN](state, authToken) {
    state.authToken = authToken;
  },
  [types.USER_INFO](state, userInfo) {
    state.userInfo = userInfo;
  },
  [types.OWNER_JUSO](state, ownerJuso) {
    state.ownerJuso = ownerJuso;
  },
  // 공인중개사
  [types.AGT_PROPERTY_INQUIRY_STEP1](state, agreement) {
    state.propertyInquiry.agreement = agreement;
  },
  [types.AGT_PROPERTY_INQUIRY_STEP2](state, certification) {
    state.propertyInquiry.certification = certification;
  },
  [types.AGT_PROPERTY_INQUIRY_STEP3](state, propertyInfo) {
    state.propertyInquiry.propertyInfo = propertyInfo;
  },

  // 임대인
  [types.PROPERTY_INQUIRY_STEP1](state, certification) {
    state.propertyInquiry.certification = certification;
  },
  [types.PROPERTY_INQUIRY_STEP2](state, agreement) {
    state.propertyInquiry.agreement = agreement;
  },
  [types.PROPERTY_INQUIRY_STEP3](state, contractInfo) {
    state.propertyInquiry.contractInfo = contractInfo;
  },
  [types.PROPERTY_INQUIRY_STEP4](state, propertyInfo) {
    state.propertyInquiry.propertyInfo = propertyInfo;
  },

  [types.PROPERTY_CLEAR](state) {
    console.log("=======clear 하자");
    // 초기화
    state.propertyInquiry = {
      certification: {
        //공인중개사, 임대인 공통
        ownerName: null, //소유주 이름
        ownerAddr: null, // 소유주 주소
        ownerAddrDetail: null, //소유주 상세주소
        ownerTel: null, // 소유주 휴대폰

        //공인중개사
        contFile: {
          data: null, // request body
          fileList: [],
          idArr: [],
          removedIdArr: []
        }, //전속중개계약서 파일

        //임대인
        locationInfo: {},

        propertyJAddr: null, //매물 지번 주소
        propertyRAddr: null, // 매물 도로명 주소
        propertyLat: null, //매물 위도
        propertyLong: null, //매물 경도

        AddrDong: null, //동
        AddrHo: null, //호
        AddrFloor: null, //층

        fullRAddr: null, //주소+동호층 (도로명)
        fullJAddr: null, //주소+동호층 (지번)

        dongDisable: false, //dong 없을 때 selectbox disable
        hoDisable: false, //ho 없을 때 selectbox disable
        flrCheckShow: null, // 층 관련 체크박스 show 여부
        allFloor: null, //층 전체 체크박스
        partFloor: null, //층 일부 체크박스
        partArea: null, // 층 일부 직접 입력한 면적
        hoTitle: null, //층 일부인 경우 해당 공간 이름

        legalCode: null, //법정동 코드

        newBun: null, //api를 위해 만든 번
        newJi: null, //api를 위해 만든 지

        genBdList: null, //총괄표제부
        bdList: [], //표제부 리스트
        brdList: [], // 용도지역
        selectedBd: null, //해단 표제부
        selectedDongIdx: null, //선택된 동 idx
        hoList: [], //호 리스트
        flrList: [], //층 리스트

        useArea: null, // 전용면적
        provArea: null, // 공급면적
        bdNm: null, //건물명
        strct: null, // 구조
        purpsDetail: null, // 용도
        platArea: null, //대지면적
        totArea: null, //연면적
        buildYear: null, //건축년도
        useAprDay: null, //사용승인 일자
        hhldCnt: null, //총 세대 수
        grndFlrCnt: null, //지상 층 수
        totPkngCnt: null, // 총 주차대수
        jpvTypeCd: null, // 매물유형(아파트, 빌라, 주택, 오피스텔)
        platGbCd: null, // 대지구분코드
        platGbCdNm: null // 대지구분코드명(0:대, 1:산, 2:블록)
      },

      agreement: {
        svcAgrmtYn: null, // 서비스 이용 약관
        contractYn: null, //전속중개계약 체결 동의
        privacyYn: null // 개인정보 수집 및 이용 동의
      },

      contractInfo: {
        //page 1
        p1LeaseCheck: null, //임대 체크
        type: null, // 임대, 임차 ... id from coCode

        provideData: null, //정보 공개여부

        contrValYear: null, //계약 유효기간 년
        contrValMonth: null, //월
        contrValDay: null, //일
        contrValUTC: null, // 계약 만료일 UTC

        brokCompenRate: null, //중개보수 거래가액의 %
        brokCompenPrice: null, //중개보수 가격 (원)

        writeYear: null, // 계약서 작성일 년도
        writeMonth: null, // 계약서 작성일 월
        writeDay: null, // 계약서 작성일 일

        clientAddr: null, // 중개의뢰인 주소
        clientName: null, // 중개의뢰인 성명
        clientBirth: null, // 중개의뢰인 생년월일
        clientTel: null, // 중개의뢰인 전화번호

        brokerAddr: null, //공인중개사 주소
        brokerName: null, //공인중개사 이름
        companyName: null, //상호(명칭)
        brokerResNum: null, //공인중개사 등록번호
        brokerBirth: null, //공인중개사 생년월일
        brokerTel: null, //공인중개사 전화번호

        imageUrl: null, //서명 파일Url

        //page 2
        p2LeaseCheck: null, //page2 권리이전용 구분- 임대 체크박스

        ownerName: null, //소유주 성명
        ownerBirth: null, //소유주 생년월일
        ownerFullAddr: null, //소유주 전체 주소 ==> computed

        buildingAddr: null, //건축물 소재지
        buildYear: null, //건축년도
        buildingArea: null, //건축물 면적
        buildingStruct: null, //건축물 구조
        buildingPurpose: null, //건축물 용도

        landAddr: null, //토지 소재지
        landPurpose: null, //토지 지목
        landArea: null, //토지 면적
        landPlace: null, //토지 지역,지구 등
        landPrstPurp: null, //토지 현재 용도

        otherFee: null, // 은행융자, 권리금, 제세공과금 등

        rightRel: null, // 권리관계
        regulation: null, //거래규제 및 공법상 제한사항
        leaseYn: "1", //거래유형(전세 =true, 월세 = false)
        paymentTypeId: null, //전세, 월세 id from coCode
        deposit: null, //중개의뢰금액 보증금
        monthlyPay: null, //중개의뢰금액 월세
        etc: null //그 밖의 사항
      },

      propertyInfo: {
        // ownerName: null, //소유주 이름
        // ownerAddr: null, // 소유주 주소
        // ownerAddrDetail: null, //소유주 상세주소
        // ownerTel: null, // 소유주 휴대폰

        propertyJAddr: null, //건물 지번 주소
        propertyRAddr: null, //건물 도로명 주소
        propertyLat: null, //매물 위도  --일반 step4에 없음
        propertyLong: null, //매물 경도  --일반 step4에 없음

        selectedDongIdx: null, //
        AddrDong: null, //동
        AddrHo: null, //호
        AddrFloor: null, //층
        flrJustNum: null, // 층 숫자만
        hoJustNm: null, // 호 이름만
        dongJustNm: null, // 동 이름만

        locationInfo: {}, // 매물 주소 총정보
        fullRAddr: null, //주소+동호층 (도로명)
        fullJAddr: null, //주소+동호층 (지번)

        dongDisable: false,
        hoDisable: false,

        allFloor: false, // 층 전체 체크박스
        partFloor: false, //층 일부 체크박스
        partArea: null, // 층 일부 직접 입력한 면적  --일반 step4에 없음
        hoTitle: null, // 직접입력한 호 명칭
        flrCheckShow: false,

        legalCode: null,

        newBun: null, // for문으로 만든 bun
        newJi: null, // for문으로 만든 ji
        jiBun: null, // 지번주소의 지번
        legalDong: null, // 법정동

        genBdList: [], //총괄표제부
        bdList: [], // 표제부 리스트
        selectedBd: null, //해당 표제부

        hoList: [], //호 리스트

        flrList: [], // 층 리스트

        //=============================================
        strct: null, // 건축물 구조
        rawBrdList: [], // 용도지역 원본 리스트 (ex)['일반주거지역', '공업지역'] )
        brdList: null, // 용도지역
        purps: null, //건축물 용도
        purpsDetail: null, // 건축물 세부용도
        jpvTypeCd: null, //아파트, 빌라, 주택, 오피스텔
        isOnlyRoom: null, //원룸 여부
        platArea: null, // 대지면적
        totArea: null, // 연면적
        hhldCnt: null, // 총 세대수
        bdNm: null, //건물명
        permitDate: null, //사용승인 일자
        totPkngCnt: null, //총 주차대수
        platGbCd: null, // 대지구분 코드

        rawCTT: null, // 단순한 월세 전세 string값(불러오기 용도)
        paymentType: null, //거래유형
        deposit: null, //보증금
        monthlyPay: null, //월세
        pmdNotMdf: null, // 포맷 수정 안된 입주가능일(불러오기 용도)
        possibleMoveDate: null, // 입주가능일
        imdMove: false, // 즉시입주(true, false)
        loanYn: null, //전세자금대출 가능여부

        provArea: null, // 공급면적
        useArea: null, //전용면적
        grndFlrCnt: null, //총 층
        TNORooms: null, //방 수
        TNORoomsDirect: false, //방개수 직접입력인지 아닌지
        TNOBathRooms: null, //욕실 수
        TNOBathRoomsDirect: false, //욕실개수 직접입력인지 아닌지
        eleYn: null, // 승강기 여부
        heatingType: null, //난방방식
        heatingFuel: null, //난방연료
        entStructure: null, //현관구조
        directionStd: null, //방향 기준
        direction: null, //방향
        verandaYn: false, //베란다 체크박스
        balconyYn: false, // 발코니 체크박스
        parkingYn: null, // 주차가능여부
        PknPerFmly: null, // 가구당 주차가능대수
        maintenanceFee: null, //관리비
        maintenList: [], //선택된 관리비 포함항목
        useFeeYn: null, //사용료
        useFeeList: [], //선택된 사용료 포함항목

        optionYn: null, //옵션 유무
        optionList: [], //선택된 옵션들
        securityYn: null, //보안시설 유무
        securityList: [], //선택된 보안시설
        petYn: null, // 반려동물 가능여부
        possibleVisitDays: [], //방문 가능 요일
        possibleVisitTimes: [], //방문 가능 시간

        extrExpl: null, //매물 추가 설명

        oneHouseAgr: null, // 추가정보 동의 YN (단독주택 경우)
        shareHouseAgr: null, // 추가정보 동의 YN (공동주택 경우)

        G_Img_File: {
          data: null, // request body
          fileList: [],
          idArr: [],
          removedIdArr: []
        }, //일반 이미지 파일

        Vr_Img_File: {
          data: null, // request body
          fileList: [],
          idArr: [],
          removedIdArr: []
        }, //vr이미지 파일

        etcComment: null //기타 의견
      }
    };
  }
};
